import { render, staticRenderFns } from "./UnidentifiedObjectCaution.vue?vue&type=template&id=2a2427f0&"
import script from "./UnidentifiedObjectCaution.vue?vue&type=script&lang=js&"
export * from "./UnidentifiedObjectCaution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports